import { apiClient, getPlatformUrl } from "../../lib/api";
import { getIsNewDb } from "../../lib/is-new-db";

export class DashboardGateway {
  async fetchDemography(req: any): Promise<any> {
    // 2 フェーズ取込 = v3。legacy = v2。
    const ver = getIsNewDb() ? "v3" : "v2";
    const url = `${getPlatformUrl()}/xcausal/${ver}/demographic`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchTrend(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const ver = getIsNewDb() ? "v3" : "v2";
    const url = `${getPlatformUrl()}/xcausal/${ver}/trend?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchDistribute(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const ver = getIsNewDb() ? "v3" : "v2";
    const url = `${getPlatformUrl()}/xcausal/${ver}/distribution?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchKpiAttrs(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/kpi/nodes`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async updateKpiAttrs(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/kpi/nodes`;
    const res = await apiClient.update({ url: url, body: req });
    return res as any;
  }

  async fetchKpi(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/kpi`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchLayer(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/layer_freq`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchRanking(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/node_layer_ranking?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchHeatmap(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/symptom_ranking`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }
}
